import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import Loader from "react-loader-spinner";

class CustomPronunciationSubstitutions extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false,
        hideAddDialog: false,
        hideDeletePopup: false,
        DeleteAllPopup: false,
        hideDeleteAllPopup: false,
        hideIncorrectPassword: false,
      });
    };

    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };
    this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };

    this.settings = { effect: "Zoom", duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [
      {
        buttonModel: {
          content: "OK",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.fetchSubstitutionApi();
          this.dialogClose();
        },
      },
    ];
    this.addedButton = [
      {
        buttonModel: {
          content: "OK",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.fetchSubstitutionApi();
          this.dialogClose();
          this.setState({
            disabled: false,
          });
        },
      },
    ];

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteSubstitutionApi(this.state.propsId);
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //deleteall text confirmation
    this.textAreaConfir = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.deleteInputValidation();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideTextAreaPopup: false,
          });
        },
      },
    ];
    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideTextAreaPopup: true,
            hideIncorrectPassword: false,
          });
        },
      },
    ];

    //for delete success
    this.deleteSuccessbuttons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.dialogInstance.hide();
          this.fetchSubstitutionApi();
          this.setState({ disabled: false });
        },
      },
    ];
    //deleteall
    this.deleteAllButton = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteAllPopup: false,
            hideTextAreaPopup: true,
          });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteAllPopup: false,
          });
        },
      },
    ];
    this.state = {
      data: [
        {
          id: "",
          originalText: "",
          substitution: "",
          deleteRow: false,
        },
      ],
      hideIncorrectPassword: false,
      hideTextAreaPopup: false,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit.svg",
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      pageNum: null,
      DeleteAllPopup: true,
      hideDeleteAllPopup: false,
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
  }
  addRow = (data) => {
    var SubstitutionController = this;
    if (SubstitutionController.state.pageNum != 0) {
      SubstitutionController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      originalText: "",
      substitution: "",
      language: document.getElementById("language").value,
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    });
  };
  deleteAllSubstitutionApi = () => {
    let deleteApiViewController = this;
    $.ajax({
      url: "/api/custom-pronunciation/delete/all",
      async: false,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        language: document.getElementById("language").value,
        projectId: localStorage.getItem("currentProjectId"),
      },
      success: function (res) {
        if (res.success === true && res.result === "done.") {
          deleteApiViewController.state.hideTextAreaPopup = false;
          deleteApiViewController.state.checkBoxRows = [];
          deleteApiViewController.setState(deleteApiViewController.state);
          deleteApiViewController.fetchSubstitutionApi();
          deleteApiViewController.notifyDeleteAllSuccess();
        } else if (res.success === true && res.result != "done.") {
          deleteApiViewController.NotifyNodata(res.result);
        } else {
          deleteApiViewController.NotifyFailedDelete(res.result);
        }
      },

      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };
  NotifyFailedDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  NotifyNodata(response) {
    this.setState({
      hideTextAreaPopup: false,
    });
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  deleteInputValidation = () => {
    if (
      document.getElementById("deleteInputFromUser").value == "Delete" ||
      document.getElementById("deleteInputFromUser").value == "delete" ||
      document.getElementById("deleteInputFromUser").value == "DELETE"
    ) {
      document.getElementById("deleteInputFromUser").value = "";
      this.deleteAllSubstitutionApi();
    } else {
      this.setState({
        hideIncorrectPassword: true,
      });
    }
  };
  saveSubstitutionApi(props, e) {
    props.original.language = document.getElementById("language").value;
    props.original.originalText = document
      .getElementById("originalText" + props.index)
      .innerText.trim();
    props.original.substitution = document
      .getElementById("substitution" + props.index)
      .innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult =
      this.validateCells(props.original.originalText) &&
      this.validateCells(props.original.substitution);
    if (validateResult == true) {
      var addedData = {
        originalText: props.original.originalText,
        substitution: props.original.substitution,
        projectId: localStorage.getItem("currentProjectId"),
        language: props.original.language,
      };
      var addMltController = this;
      $.ajax({
        url: "/api/custom-pronunciation-add",
        async: false,
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            addMltController.notifyAdded();
            addMltController.fetchSubstitutionApi();
            addMltController.setState({ disabled: false });
          } else {
            addMltController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }
  }
  updateSubstitutionApi(props, e) {
    props.original.originalText = document
      .getElementById("originalText" + props.index)
      .innerText.trim();
    props.original.substitution = document
      .getElementById("substitution" + props.index)
      .innerText.trim();
    var validateResult =
      this.validateCells(props.original.originalText) &&
      this.validateCells(props.original.substitution);
    if (validateResult == true) {
      var addedData = {
        originalText: props.original.originalText,
        substitution: props.original.substitution,
      };
      var updatedData = {
        id: props.original.id,
        originalText: props.original.originalText,
        substitution: props.original.substitution,
        projectId: props.original.projectId,
        language: props.original.language,
      };
      var updatedDataController = this;
      $.ajax({
        url: "/api/custom-pronunciation-update",
        async: false,
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchSubstitutionApi();
          } else {
            updatedDataController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  deleteSubstitutionApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
    } else {
      $.ajax({
        url: "/api/custom-pronunciation-delete/" + id,
        async: false,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteRowViewController.splice(id, 1);
          } else {
            deleteRowViewController.NotifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        },
      });
    }

    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchSubstitutionApi();
  };
  queryHandleChange = (e) => {
    this.fetchByQueryApi();
  };
  fetchByQueryApi = () => {
    var fetchApiController = this;

    $.ajax({
      url: "/api/subs-tab",
      async: false,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      data: {
        language: document.getElementById("language").value,
        projectId: localStorage.getItem("currentProjectId"),
      },

      success: function (res) {
        if (res.success === true) {
          fetchApiController.setState({
            data: res.result,
          });
        } else {
          fetchApiController.NotifyFailedLoadQuer();
        }
      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ": " + xhr.statusText;
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };

  onKeyPressHandleChange = (event) => {
    if (event.key === "Enter") {
      this.fetchByQueryApi();
    }
  };

  componentDidMount() {
    this.language = document.getElementById("language").value;
    setTimeout(() => {
      this.fetchLanguageApi();
      this.fetchSubstitutionApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      if (document.getElementById("language") != null) {
        thisController.projectId = event.projectId;
        thisController.fetchLanguageApi(event.projectId);
        thisController.fetchSubstitutionApi(event.projectId);
        thisController.language = document.getElementById("language").value;
        thisController.projectId = event.projectId;
      }
    });
  }
  validateCells(code) {
    if (code == "") {
      this.notifyEmptyTagKeyFields();
      return false;
    } else {
      return true;
    }
  }
  validateCells(text) {
    if (text == "") {
      this.notifyEmptyFields();
      return false;
    } else {
      return true;
    }
  }

  refreshData = (id) => {
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchSubstitutionApi();
    this.setState({ disabled: false });
  };

  fetchSubstitutionApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    let SubstitutionController = this;
    $.ajax({
      url: "/api/get-custom-pronunciation",
      async: false,
      method: "GET",

      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      data: {
        projectId: projectId,
        language: document.getElementById("language").value,
      },
      success: function (res) {
        if (res.success === true) {
          var tagKeys = res.result;
          SubstitutionController.setState({
            data: tagKeys,
            successResp: true,
            disabled: false,
          });
        } else {
          SubstitutionController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  };
  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;All substitutions have been deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Substitution Added Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyError() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Oops! Error occurred.Please try again
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Substitution Updated Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Substitution Deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyEmptyFields() {
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; Please fill all the fields
      </b>,
      {
        position: "bottom-center",
        color: "#007aff",
      }
    );
  }

  notifyEmptyTagKeyFields() {
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; Please change the tag field
      </b>,
      {
        position: "bottom-center",
        color: "#007aff",
      }
    );
  }

  notifyEmptyFieldForAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; Please fill all the data
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedResponse(response) {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;{response}
      </b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  fetchLanguageApi(projectId) {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    var languageController = this;
    $.ajax({
      url: "/api/project-languages-selected",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var language = res.result;
          languageController.setState({ language: language });
          var numberOfLanguages = language.length;
          var ele3 = document.getElementById("language");
          if (ele3 != "") {
            if (ele3 != null) {
              ele3.innerHTML = "";
              for (var i = 0; i < numberOfLanguages; i++) {
                ele3.innerHTML =
                  ele3.innerHTML +
                  '<option value="' +
                  language[i]["code"] +
                  '">' +
                  language[i]["code"] +
                  "</option>";
              }
            }
          }
          successResp: true;
        } else {
          languageController.notifyFailedResponse(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      },
    });
  }
  deleteAllHandler = () => {
    this.setState();
  };
  handleChangeForLanguage = (event) => {
    this.setState({
      value: event.target.value,
      language: document.getElementById("language").value,
    });
    this.fetchSubstitutionApi();
  };
  render() {
    const { data } = this.state;
    const columns = [
      {
        Header: "Id",
        accessor: "id",
        show: false,
        Cell: (props) => (
          <div name="id" id={"id" + props.index}>
            {props.original.id}
          </div>
        ),
      },

      {
        Header: () => <b>Original</b>,
        accessor: "originalText",
        Cell: (props) => (
          <div name="code">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  props.original.id == "" ||
                  props.original.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.original.id == "" ? "2px" : "none",
              }}
              id={"originalText" + props.index}
              contentEditable={
                !(props.original.id == ""
                  ? false
                  : props.original.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.original.originalText}
            </div>
          </div>
        ),
      },
      {
        Header: () => <b>Substitute</b>,
        accessor: "substitution",
        Cell: (props) => (
          <div name="text">
            <div
              className="textarea"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                paddingLeft: "2px",
                paddingTop: "6px",
                width: "98%",
                border:
                  props.original.id == "" ||
                  props.original.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.original.id == "" ? "2px" : "none",
              }}
              id={"substitution" + props.index}
              contentEditable={
                !(props.original.id == ""
                  ? false
                  : props.original.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.original.substitution}
            </div>
          </div>
        ),
      },

      {
        Header: <b>Action</b>,
        accessor: "action",
        width: 200,
        Cell: (props) => (
          <div id="action">
            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
            >
              <img
                className="img-responsive"
                title={
                  props.original.id == "" ||
                  this.state.data[props.index].id == this.state.editedId
                    ? "Save"
                    : "Edit"
                }
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                src={
                  props.original.id == ""
                    ? this.saveImageSrc
                    : props.original.id != this.state.editedId
                    ? this.editImageSrc
                    : this.saveImageSrc
                }
                onClick={(e) => {
                  props.original.id == ""
                    ? this.saveSubstitutionApi(props, e)
                    : props.original.id == this.state.editedId
                    ? this.updateSubstitutionApi(props, e)
                    : this.makeCelledit(props, e);
                }}
              />
            </button>

            <button
              style={{
                backgroundColor: "#ffffff",
                border: "none",
                marginTop: "-9px",
                marginLeft: "-6px",
              }}
              title="Delete"
            >
              <img
                className="img-responsive"
                src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: "6px",
                  backgroundColor: "#282a65",
                  borderRadius: "5px",
                  padding: "1px",
                }}
                onClick={() =>
                  props.original.id === ""
                    ? this.fetchSubstitutionApi()
                    : this.setState({
                        hideDeletePopup: true,
                        deletePropIndex: props.index,
                        propsId: props.original.id,
                      })
                }
              />
            </button>
          </div>
        ),
        width: 100,
      },
    ];
    return (
      <div style={{ marginRight: "1%" }}>
        {" "}
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />
        <div
          style={{
            background: "#F9F9FB",
            display: this.state.successResp ? "block" : "none",
          }}
        >
          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          {/* for reactTable */}
          <link
            rel="stylesheet"
            href="assets/css/React_Table_CSS/react-table.css"
          />
          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | BackEnd Api </title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />
          <div className="row" style={{ marginLeft: "15px" }}>
            <div className="col-sm-4" style={{ marginTop: "2px" }}>
              <label>Language</label>
              <select
                className="language"
                id="language"
                value={this.state.value}
                onChange={this.handleChangeForLanguage}
                style={{
                  marginLeft: "15px",
                  width: "53%",
                  height: "30px",
                  borderRadius: "4px",
                  backgroundColor: "#F9F9FB",
                }}
              ></select>
            </div>
          </div>

          <div className="row" style={{ marginLeft: "14px" }}>
            <div className="col-sm-5">
              <h6
                className="nav-item"
                style={{ color: "#282a65", marginTop: "15px" }}
              >
                Correct the Pronunciation
              </h6>
            </div>
            <div className="col-sm-5" Align="right">
              {/* <button className="btn action-button" style={{ marginTop: '0px' }}
                id="addMsg" title=" Delete All "
                onClick={() => {
                  this.setState({
                    hideDeleteAllPopup: true
                  })
                }}>
                Delete All
              </button> */}
            </div>
            {/* Add button */}
            <div className="col-sm-2 " style={{ marginTop: "-18px" }}>
              <div className="d-flex flex-row-reverse pt-2">
                <div className="p-2" style={{ marginBottom: "10px" }}>
                  <button
                    className="btn action-button"
                    id="addMsg"
                    title=" Add "
                    onClick={
                      this.state.disabled
                        ? this.notifyEmptyFieldForAdd
                        : this.addRow
                    }
                  >
                    <img src="assets/images/add_white_24dp.png" />
                  </button>
                  <button
                    title="Refresh"
                    onClick={this.refreshData}
                    type="button"
                    className="btn action-button"
                  >
                    <img src="./assets/images/refresh_white_24dp.png"></img>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            className="row"
            style={{ marginLeft: "15px", marginTop: "-15px" }}
          >
            <div className="col-lg-12 ">
              <div className="card">
                <ReactTable
                  data={data}
                  columns={columns}
                  defaultPageSize={10}
                  pageSizeOptions={[5, 10, 15]}
                  onPageChange={this.onPageChange}
                  page={this.state.pageNum}
                />
              </div>
              <ToastContainer className="Toast-at-center" />
              {/*Dialog Component For Deletion Confirmation*/}
              <DialogComponent
                width="400px"
                animationSettings={this.settings}
                header="Delete Confirmation"
                showCloseIcon={true}
                buttons={this.buttons}
                ref={(dialog) => (this.dialogInstance = dialog)}
                visible={this.state.hideDeletePopup}
                close={this.dialogClose}
              >
                <img
                  src="assets/images/warn.svg"
                  style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                  content=""
                />
                &nbsp;Do you want to delete the substitution? Note: Press 'Yes'
                to delete or press 'No' to decline.
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              </DialogComponent>
              {/*Dialog Component For  Deletion all Confirmation*/}
              <DialogComponent
                width="400px"
                animationSettings={this.settings}
                header="Delete All"
                showCloseIcon={true}
                buttons={this.deleteAllButton}
                ref={(dialog) => (this.dialogInstance = dialog)}
                visible={this.state.hideDeleteAllPopup}
                close={this.dialogClose}
              >
                <img
                  src="./assets/images/warn.svg"
                  style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                  content=""
                />
                &nbsp;Do you want to delete all the substitutions?
                <br />
                Note: Press 'Yes' to delete or press 'No' to decline.
              </DialogComponent>

              <DialogComponent
                width="400px"
                animationSettings={this.settings}
                header="Incorrect Password"
                showCloseIcon={true}
                buttons={this.incorrectPasswordButtons}
                ref={(dialog) => (this.dialogInstance = dialog)}
                visible={this.state.hideIncorrectPassword}
                close={this.IncorrectPassworddialogClose}
              >
                Please type "Delete"
              </DialogComponent>

              <DialogComponent
                width="400px"
                animationSettings={this.settings}
                header="Delete Confirmation"
                showCloseIcon={true}
                buttons={this.textAreaConfir}
                ref={(dialog) => (this.dialogInstance = dialog)}
                visible={this.state.hideTextAreaPopup}
                close={this.DeletedialogClose}
              >
                Please type "Delete" for confirmation
                <input type="text" id="deleteInputFromUser" />
              </DialogComponent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CustomPronunciationSubstitutions;



// WEBPACK FOOTER //
// ./src/ttsUi/CustomPronunciation.js